"use client";
import { useRouter } from "@/lib/useRouter";

export const useRouterPush = () => {
  const router = useRouter();
  return async (url: string) => {
    return router.push(url);
  };
};
